import api from "./api";

export const trackingApi = {
  list: (query = "") => api.get(`/tracking${query}`),

  getById: (id) => api.get(`/tracking/${id}`),

  create: (payload) => api.post("/tracking", payload),

  refresh: (id) => api.post(`/tracking/${id}/refresh`),

  refreshAll: () => api.post("/tracking/refresh-all"),

  remove: (id) => api.delete(`/tracking/${id}`),

  getShippingLines: () => api.get("/tracking/shipping-lines"),

  getExistingContainers: (params = {}) =>
    api.get("/containers", {
      params: {
        page: params.page || 1,
        limit: params.limit || 100,
        search: params.search || undefined,
        status: params.status || undefined,
      },
    }),

  updateContainer: (id, payload) =>
    api.put(`/containers/${id}`, payload),
};

export default trackingApi;
